import createRoute from '@widesk-ui/tools/createRoute';
import EventModel  from '@models/website/EventModel';

const route = createRoute.splitView(
	'/website_entertainments/:websiteEntertainmentId/events',
	'website',
	'EventSplitView',
	EventModel.localize('plural'),
);
export default route;
